module.exports = __webpack_public_path__ + "img/bonus-prohibited-60.55cc7613.svg";